// Filtros da lista de Produtos (dono, 26/10/2026: "deixa mais intuitivo";
// esgotado e escondido viraram filtros separados, receita saiu da tela).
// Cada grupo é uma fileira de opções; "todos" não filtra. As regras de ficha
// técnica e nota fiscal vêm da página (as mesmas das bolinhas do cartão).
const temTexto = (s) => !!(s && String(s).trim());

export const TODOS = "todos";

export const FILTROS_VAZIOS = {
  tipo: TODOS, categoria: TODOS, estoque: TODOS, visivel: TODOS,
  foto: TODOS, descricao: TODOS, ficha: TODOS, fiscal: TODOS,
};

// Receita é cadastrada no Estoque (Nova receita) e não vai para o cardápio
export const ehDoCardapio = (p) => p.product_type !== "receita";

export function criarGrupos({ vendavel, temFicha, fiscalPronto }) {
  return [
    { chave: "tipo", titulo: "Tipo", todos: "Todos", opcoes: [
      { valor: "produto", rotulo: "Produto", teste: (p) => (p.product_type || "produto") === "produto" },
      { valor: "combo", rotulo: "Combo", teste: (p) => p.product_type === "combo" },
      { valor: "pizza", rotulo: "Pizza", teste: (p) => p.product_type === "pizza" },
    ] },
    { chave: "estoque", titulo: "Estoque", todos: "Todos", opcoes: [
      { valor: "disponivel", rotulo: "Disponíveis", etiqueta: "Disponíveis", teste: (p) => p.available !== false },
      { valor: "esgotado", rotulo: "Esgotados", etiqueta: "Esgotados", teste: (p) => p.available === false },
    ] },
    { chave: "visivel", titulo: "Visibilidade", todos: "Todos", opcoes: [
      { valor: "visivel", rotulo: "Visíveis", etiqueta: "Visíveis", teste: (p) => !p.hidden },
      { valor: "escondido", rotulo: "Escondidos", etiqueta: "Escondidos", teste: (p) => p.hidden === true },
    ] },
    { chave: "foto", titulo: "Foto", todos: "Todas", opcoes: [
      { valor: "com", rotulo: "Com", etiqueta: "Com foto", teste: (p) => temTexto(p.photo_url) },
      { valor: "sem", rotulo: "Sem", etiqueta: "Sem foto", teste: (p) => !temTexto(p.photo_url) },
    ] },
    { chave: "descricao", titulo: "Descrição", todos: "Todas", opcoes: [
      { valor: "com", rotulo: "Com", etiqueta: "Com descrição", teste: (p) => temTexto(p.description) },
      { valor: "sem", rotulo: "Sem", etiqueta: "Sem descrição", teste: (p) => !temTexto(p.description) },
    ] },
    { chave: "ficha", titulo: "Ficha técnica", todos: "Todas", opcoes: [
      { valor: "com", rotulo: "Com", etiqueta: "Com ficha", teste: temFicha },
      { valor: "sem", rotulo: "Sem", etiqueta: "Sem ficha", teste: (p) => vendavel(p) && !temFicha(p) },
    ] },
    { chave: "fiscal", titulo: "Nota fiscal", todos: "Todos", opcoes: [
      { valor: "com", rotulo: "Prontos", etiqueta: "Prontos p/ nota", teste: (p) => vendavel(p) && fiscalPronto(p) },
      { valor: "sem", rotulo: "Sem dados", etiqueta: "Sem dados fiscais", teste: (p) => vendavel(p) && !fiscalPronto(p) },
    ] },
  ];
}

export function aplicarFiltros(lista, filtros, grupos) {
  let saida = lista;
  if (filtros.categoria && filtros.categoria !== TODOS) {
    saida = saida.filter((p) => p.category === filtros.categoria);
  }
  for (const g of grupos) {
    const op = g.opcoes.find((o) => o.valor === filtros[g.chave]);
    if (op) saida = saida.filter(op.teste);
  }
  return saida;
}

// Etiquetas do que está valendo (aparecem com o painel fechado)
export function filtrosAtivos(filtros, grupos) {
  const ativos = [];
  if (filtros.categoria && filtros.categoria !== TODOS) {
    ativos.push({ chave: "categoria", rotulo: filtros.categoria });
  }
  for (const g of grupos) {
    const op = g.opcoes.find((o) => o.valor === filtros[g.chave]);
    if (op) ativos.push({ chave: g.chave, rotulo: op.etiqueta || op.rotulo });
  }
  return ativos;
}
